import * as FateActionTypes from 'actiontypes/fate';
import { IFateState } from 'types/fate';


import fetchSuccess from './fetchSuccess';
import purchaseItemSuccess from './purchaseItemSuccess';

/**
 * Initial state
 * @type {Object}
 */
const INITIAL_STATE: IFateState = {
  activePurchase: null,
  hasFetched: false,
  isExceptionalFriend: false,
  isFetching: true,
  isPurchasing: false,
  purchaseComplete: false,
  data: {
    currentFate: 0,
    fateCards: [],
    premiumSubPurchaseCard: undefined,
  },
  isDialogOpen: false,
  message: null,
  avatarSelected: null,
};

/**
 * Fate Reducer
 * @param {Object} state
 * @param {[Object]} action
 */
const Fate = (state = INITIAL_STATE, action: any) => {
  const { payload = {} } = action;

  switch (action.type) {
    case FateActionTypes.PROCESS_FATE_CHANGE:
      const { data: { currentFate } } = state;
      return {

        ...state,
        data: {
          ...state.data,
          currentFate: currentFate + action.fateChangeAmount,
        }
      };
    case FateActionTypes.FETCH_REQUESTED:
    case FateActionTypes.FETCH_FAILURE:
      return {
        ...state,
        isFetching: action.isFetching,
        purchaseComplete: false,
      };

    case FateActionTypes.FETCH_SUCCESS:
      return fetchSuccess(state, payload);

    case FateActionTypes.PURCHASE_ITEM_REQUESTED:
      return {
        ...state,
        isPurchasing: true,
        purchaseComplete: false,
      };

    case FateActionTypes.PURCHASE_ITEM_SUCCESS:
      return purchaseItemSuccess(state, payload);

    case FateActionTypes.PURCHASE_ITEM_FAILURE:
      return { ...state, isPurchasing: false };

    case FateActionTypes.OPEN_PURCHASE_DIALOG:
      return {
        ...state,
        activePurchase: action.item,
        isDialogOpen: action.isDialogOpen,
        isChangingName: false,
      };

    case FateActionTypes.CLOSE_PURCHASE_DIALOG:
      return {
        ...state,
        activePurchase: null,
        isDialogOpen: action.isDialogOpen,
        purchaseComplete: false,
        avatarSelected: null,
        isPurchasing: false,
        isChangingName: false,
      };

    case FateActionTypes.SELECT_AVATAR:
      return {
        ...state,
        avatarSelected: action.avatar,
      };

    case FateActionTypes.OPEN_FATE_DIALOG:
      return {
        ...state,
        activePurchase: state.data.fateCards.find(({ id }) => id === action.id),
        isDialogOpen: true,
        isChangingName: false,
      };

    default:
      return state;
  }
};

export default Fate;
